<template>
  <div class="products-list">
    <div class="row">
      <div class="col-sm-6 col-md-4 col-lg-4" v-for="(item, index) in products_list" :key="index">
        <CardTemplateDiscount :item="item" />
      </div>
    </div>
  </div>
</template>
<script>
import CardTemplateDiscount from '@/components/products/catalog/CardTemplateDiscount';

export default {
  name: 'productslist',
  props: ['products_list'],
  components: { CardTemplateDiscount },
  data() {
    return {
      selectedProduct: Object,
    };
  },
};
</script>
